import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { toast } from 'sonner';
import { AlertTriangle } from 'lucide-react';

const DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export function NutritionExceptions() {
  const [items, setItems] = useState([]);
  const load = () => api.get('/admin/nutrition-exceptions').then(r => setItems(r.data || [])).catch(() => setItems([]));
  useEffect(() => { load(); }, []);
  const resolve = async (id) => {
    try { await api.post(`/admin/nutrition-exceptions/${id}/resolve`); toast.success('Marked as reviewed'); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || 'Failed'); }
  };
  if (!items.length) return null;
  return (
    <div className="regen-card-elevated p-4 border border-red-500/30" data-testid="nutrition-exceptions">
      <div className="flex items-center gap-2 mb-3">
        <AlertTriangle className="w-4 h-4 text-red-400" />
        <div className="font-display font-bold">{items.length} nutrition plan{items.length > 1 ? 's need' : ' needs'} review</div>
      </div>
      <div className="space-y-3">
        {items.map(x => (
          <div key={x.assignment_id} className="rounded-lg bg-[var(--c-film)] p-3 text-xs" data-testid={`nutrition-exception-${x.assignment_id}`}>
            <div className="flex items-center justify-between gap-2">
              <div className="font-semibold text-sm">{x.client_name} · {x.name}</div>
              <button onClick={() => resolve(x.assignment_id)} data-testid={`resolve-exception-${x.assignment_id}`}
                className="px-2 py-1 rounded-md border border-[var(--c-hair)] hover:bg-[var(--c-elev)]">Mark reviewed</button>
            </div>
            <ul className="mt-1.5 list-disc pl-4 text-muted-foreground">{x.issues.map((s, i) => <li key={i}>{s}</li>)}</ul>
            {x.flagged_days.length > 0 && (
              <div className="mt-1.5 font-mono text-[11px] text-red-400 space-y-0.5">
                {x.flagged_days.slice(0, 6).map((d, i) => (
                  <div key={i}>W{d.week} {DAYS[d.day_index]}: {d.actual_kcal} / {d.target_kcal} kcal ({d.deviation_kcal > 0 ? '+' : ''}{d.deviation_kcal}) — {d.reason}</div>
                ))}
                {x.flagged_days.length > 6 && <div>+{x.flagged_days.length - 6} more flagged days</div>}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
